exports.init = function() {
    window.proxyVote = {};
}